import React from 'react';
import { TextField, Paper, Typography, Box } from '@mui/material';

interface EditorPanelProps {
  qrText: string;
  markdownText: string;
  setQrText: (text: string) => void;
  setMarkdownText: (text: string) => void;
}

const EditorPanel: React.FC<EditorPanelProps> = ({
  qrText,
  markdownText,
  setQrText,
  setMarkdownText,
}) => {
  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Editor
      </Typography>

      <Box sx={{ mb: 2 }}>
        <TextField
          label="QR Text"
          fullWidth
          value={qrText}
          onChange={e => setQrText(e.target.value)}
        />
      </Box>

      <TextField
        label="Markdown"
        multiline
        rows={6}
        fullWidth
        value={markdownText}
        onChange={e => setMarkdownText(e.target.value)}
      />
    </Paper>
  );
};

export default EditorPanel;
